import en from './locales/en.json'
import tw from './locales/zh-TW.json'
import ja from './locales/ja-JP.json'
import zhCN from './locales/zh-CN.json'
import vi from './locales/vi.json'

const resources = {
  en: {
    translation: en,
  },
  'zh-TW': {
    translation: tw,
  },
  'ja-JP': {
    translation: ja,
  },
  'zh-CN': {
    translation: zhCN,
  },
  vi: {
    translation: vi,
  },
}

export default resources
